import { history } from '../_helpers/history';
import { alertActions } from './alert.actions'
import { telehealthService } from '../_services/telehealth.service';
import { telehealthConstants } from '../_constants/telehealth.constants';
import httpStatus from 'http-status';

export const telehealthActions = {
  setChartId,
  setGroupId,
  setLastName,
  setFirstName,
  setProviderId,
  setAvailableOn,
  setDateOfBirth,
  setPatientType,
  setPaymentAmount,
  setTelehealthDate,
  setCellPhoneNumber,
  setQuestionnaireId,

  saveTelehealth,
  getTelehealthById,
  getAllTelehealths,
  searchRooms,
  searchTelehealths,
  retrieveTelehealths,

  setTelehealthMessage,
  addTelehealthMessage,
  sendTelehealthMessage,
  getTelehealthMessages,

  clearState,
  setTelehealth,
  prependMessage
};

function clearState() {
  return { type: telehealthConstants.TH_CLEAR_STATE }
}

function setTelehealth(telehealth) {
  return { type: telehealthConstants.RETRIEVE_TELEHEALTH_SUCCESS, telehealth }
}

function prependMessage(message) {
  return { type: telehealthConstants.TH_PREPEND_MSG, message: {
    id: message.message_id,
    sentAt: message.sent_at,
    sentBy: message.from,
    ...message
  }}
}

function getAllTelehealths(params) {
  return dispatch => {
    dispatch(request());

    telehealthService.getAll(params)
      .then((collection) => {
        dispatch(success(collection));
      })
      .catch(() => {
        dispatch(alertActions.error("Could not retrieve telehealths."));
      });
  }

  function request() { return { type: telehealthConstants.GETALL_TELEHEALTHS_REQUEST } }
  function success(collection) { return { type: telehealthConstants.GETALL_TELEHEALTHS_SUCCESS, collection } }

}

function getTelehealthById(telehealthId) {
  return dispatch => {
    dispatch(request());

    telehealthService.getById(telehealthId)
      .then((telehealth) => {
        dispatch(success(telehealth));
      })
      .catch(() => {
        dispatch(failure());

        dispatch(alertActions.error("Could not retrieve the telehealth at this time. Please try again."));
      });
  }

  function request() { return { type: telehealthConstants.RETRIEVE_TELEHEALTH_REQUEST } }
  function success(telehealth) { return { type: telehealthConstants.RETRIEVE_TELEHEALTH_SUCCESS, telehealth } }
  function failure() { return { type: telehealthConstants.RETRIEVE_TELEHEALTH_FAILURE } }
}

function retrieveTelehealths(params = {}) {
  return dispatch => {
    telehealthService.getAll(params)
      .then((collection) => {
        dispatch(success(collection));
      })
      .catch(() => {
        dispatch(alertActions.error("Could retrieve the telehealths at this time. Please try again."));
      });
  }

  function success(collection) { return { type: telehealthConstants.GETALL_TELEHEALTHS_SUCCESS, collection } }
}

function searchRooms(params = {}) {
  return dispatch => {
    dispatch(request());

    telehealthService.getRooms(params)
      .then((collection) => {
        dispatch(success(collection.data));
      })
      .catch(() => {
        dispatch(alertActions.error("Could not retrieve telehealth rooms."));
      });
  }

  function request() { return { type: telehealthConstants.TH_ROOMS_REQUEST } }
  function success(rooms) { return { type: telehealthConstants.TH_ROOMS_SUCCESS, rooms } }
}

function searchTelehealths(params = {}) {
  return dispatch => {
    dispatch(request());

    telehealthService.getAll(params)
      .then((collection) => {
        dispatch(success(collection));
      })
      .catch(() => {
        dispatch(alertActions.error("Could not retrieve telehealths."));
      });
  }

  function request() { return { type: telehealthConstants.GETALL_TELEHEALTHS_REQUEST } }
  function success(collection) { return { type: telehealthConstants.GETALL_TELEHEALTHS_SUCCESS, collection } }
}

function saveTelehealth() {
  return (dispatch, getState) => {
    const telehealth = getState().telehealth.current;

    dispatch(request());

    telehealthService.schedule(telehealth)
      .then((response) => {
        dispatch(success(response.data.data));

        history.push('/telehealths');

        dispatch(alertActions.success('telehealth scheduled!'));
      })
      .catch(error => {
        if (error.response && error.response.status === httpStatus.FORBIDDEN ) {
         dispatch(alertActions.error("You don't have permission to perform this action."));
        } else {
         dispatch(alertActions.error('Could not schedule the telehealth appointment at this time. Please try again later.'));
        }
      });
  }

  function request() { return { type: telehealthConstants.SAVE_TELEHEALTH_REQUEST } }
  function success(telehealth) { return { type: telehealthConstants.SAVE_TELEHEALTH_SUCCESS, telehealth } }
  // function failure (errors) { return { type: telehealthConstants.SAVE_telehealth_FAILURE, errors }}

}

function setFirstName(firstName) {
  return { type: telehealthConstants.SET_FIRST_NAME, firstName }
}

function setLastName(lastName) {
  return { type: telehealthConstants.SET_LAST_NAME, lastName }
}

function setDateOfBirth(dateOfBirth) {
  return { type: telehealthConstants.SET_DATE_OF_BIRTH, dateOfBirth }
}

function setCellPhoneNumber(cellPhoneNumber) {
  return { type: telehealthConstants.SET_CELL_PHONE_NUMBER, cellPhoneNumber }
}

function setChartId(chartId) {
  return { type: telehealthConstants.SET_CHART_ID, chartId }
}

function setAvailableOn(date) {
  return { type: telehealthConstants.SET_AVAILABLE_ON, date }
}

function setTelehealthDate(telehealthDate) {
  return { type: telehealthConstants.SET_TELEHEALTH_DATE, telehealthDate }
}

function setGroupId(id) {
  return { type: telehealthConstants.SET_GROUP_ID, id }
}

function setProviderId(id) {
  return { type: telehealthConstants.SET_PROVIDER_ID, id }
}

function setQuestionnaireId(id) {
  return { type: telehealthConstants.SET_QUESTIONNAIRE_ID, id }
}

function setPaymentAmount(amount) {
  return { type: telehealthConstants.SET_PAYMENT_AMOUNT, amount }
}


function setPatientType(patientType) {
  return { type: telehealthConstants.SET_PATIENT_TYPE, patientType }
}

function setTelehealthMessage(message) {
  return { type: telehealthConstants.SET_TELEHEALTH_MSG, message }
}

function addTelehealthMessage(message) {
  return { type: telehealthConstants.ADD_TELEHEALTH_MSG, message }
}

function sendTelehealthMessage(appointmentId, message) {
  return dispatch => {
    dispatch(request());

    telehealthService.sendMessage(appointmentId, message)
      .then((response) => {
        dispatch(success(response));
      });
  }
  function request() { return { type: telehealthConstants.SEND_TELEHEALTH_MSG_REQUEST } }
  function success(response) { return { type: telehealthConstants.SEND_TELEHEALTH_MSG_SUCCESS, response } }
}

function getTelehealthMessages(appointmentId) {
  return (dispatch) => {
    dispatch(request());

    telehealthService.getMessagesByApptId(appointmentId)
      .then((response) => {
        const msgs = response.data.map((message) => {
          return {
            id: message.message_id,
            sentAt: message.sent_at,
            sentBy: message.from,
            ...message
          }
        })
        dispatch(success(msgs));
      })
  }
  function request() { return { type: telehealthConstants.GETALL_TELEHEALTH_MSG_REQUEST } }
  function success(messages) { return { type: telehealthConstants.GETALL_TELEHEALTH_MSG_SUCCESS, messages } }
}
